/**
 * Created by vsuthar on 9/24/21
 * File: ProductNameRendere
 * Project: Cloud Management Module ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { useCallback, useContext, useMemo } from 'react'
import { Body, Button, Tooltip, useModal } from '@panwds/react-ui'
import { InfoIcon, OpenNewBrowserIcon } from '@panwds/icons'
import {
  APP_ID_BACKBONE,
  APP_ID_DSS_ID,
  APP_ID_PRISMA_ACCESS_PANORAMA, SHARED_INSTANCE
} from '../../../../common/constants/GlobalConstants'
import { DATA_TEST_ID_ROW_EXTERNAL_ICON } from '../../../../common/constants/TestingDataIds'
import { isAppCanBeLaunched, launchAppInstance } from '../../../../common/utils/Sparky'
import AppContext from '../../../../common/context/AppContext'
import { ARRAY } from '../../../../common/utils/Utils'
import PanoramaOTPModal from '../PanoramaOTPModal'
import { BUTTON_GENERATE_OTP } from '../../../constants/LabelConstants'

const ProductNameRenderer = ({ value, globalDispatch, hideGlobalModule, row, instances = [] }) => {
  const { openModal } = useModal(PanoramaOTPModal)
  const openOTPModal = () => {
    openModal({
      data: row.original
    })
  }
  const [app_id, original, canLaunch] = useMemo(() => {
    let app_id = value
    let original = row?.original
    if (row?.depth === 0 && ARRAY.hasArray(row?.subRows) && !row?.isExpanded) {
      app_id = row?.subRows[0]?.original?.app_id
      original = row?.subRows[0]?.original
    }
    const canLaunch = isAppCanBeLaunched(original)
    return [app_id, original, canLaunch]
  }, [row?.depth, row?.isExpanded, row?.original, row?.subRows, value])

  const url = original?.url
  const tsg_id = original?.tsg_id

  const { getAppName } = useContext(AppContext)

  const handleOnProductClick = useCallback(() => {
    launchAppInstance({ app_id, tsg_id, url })
  }, [app_id, tsg_id, url])

  const showLink = useMemo(() => {
    return original?.provisioning_status === 'complete' && original?.status === 'running'
  }, [original])

  const appName = useMemo(() => {
    return getAppName(app_id) === 'None' ? '' : getAppName(original?.app_id_display_override || app_id, original?.app_id_display_override)
  }, [app_id, getAppName, original])

  const extranalIcon = !canLaunch &&
    <div className='cm-w-4'>
      <OpenNewBrowserIcon size='xxs' data-testid={DATA_TEST_ID_ROW_EXTERNAL_ICON} className='tw-text-blue-600'/>
    </div>
  return (
    <div className="tw-h-full tw-truncate tw-flex-col tw-flex cm-py-2">
      {appName && showLink && (
        <div className='tw-flex tw-flex-col'>
          <a
            className={'tw-flex tw-flex-row tw-gap-1 tw-items-baseline tw-cursor-pointer'}
            onClick={handleOnProductClick}
          >
            <Body addClassName='tw-text-blue-600 tw-truncate tw-h-full'>{appName}</Body>
            { // Need to check with Wilson after vacation and remove mssp hardcoding
              app_id !== APP_ID_BACKBONE && extranalIcon
            }
          </a>
          {value === APP_ID_DSS_ID && row?.original?.original_tsg_id && <div className='tw-flex tw-flex-row'>
            <Body size='sm' addClassName='tw-text-blue-600 tw-truncate tw-h-full tw-pt-1'>{SHARED_INSTANCE}</Body>
            <Tooltip
              label={'Sharing the CIE instance with Parent or Root'}
            >
              <div className='tw-flex tw-items-center'>
                <Button
                  size='sm'
                  aria-label='contract-button'
                  icon={<InfoIcon size="xs" className="tw-text-icon-gray" />}
                  appearance='clear'
                  style={{ background: 'transparent' }}
                />
              </div>
            </Tooltip>
          </div>}
        </div>
      )}
      {!showLink && appName &&
        <div className={'tw-flex tw-items-center'}>
          <Body addClassName='tw-text-blue-600 tw-truncate tw-mr-1'>{appName}</Body>
          {/*{extranalIcon}*/}
        </div>}
      {app_id === APP_ID_PRISMA_ACCESS_PANORAMA && <Button
        size='sm'
        appearance="primary"
        onClick={openOTPModal}>
        {BUTTON_GENERATE_OTP}
      </Button>}
    </div>
  )
}

ProductNameRenderer.propTypes = {}
export default ProductNameRenderer

